import { alpha, Theme } from '@mui/material'

const useStyles = {
  navBarPaper: (theme: Theme, moreMenuOpen: boolean) => ({
    width: '100%',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    paddingBottom: '16px',
    zIndex: moreMenuOpen ? theme.zIndex.drawer + 3 : 1201, // Keep the bottom navigation above the More drawer when it is open and above the contact cards (zIndex of 1200) but below the full screen drawer when the More drawer is closed.
    borderRadius: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: alpha(theme.palette.background.paper, 0.2),
    backdropFilter: 'blur(5px)',
  }),
  badge: {
    '& .MuiBadge-dot': {
      top: '25%',
      right: '30%',
      border: '1px solid #FFF',
    },
  },
  nav: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceContainer,
    borderRadius: '1000px',
    width: '100%',
    maxWidth: '350px',
  }),
  navAction: (theme: Theme) => ({
    '& .MuiBottomNavigationAction-label': {
      zIndex: 1,
      color: theme.palette.text.secondary,
      '&.Mui-selected': {
        color: theme.palette.text.primary,
      },
    },
    '&:after': {
      width: '100%',
      left: 0,
      top: 0,
      height: '64px',
      borderRadius: '1000px',
    },
    '&.Mui-selected:after': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:hover:after': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:focus:after': {
      backgroundColor: 'transparent',
    },
  }),
  moreMenuSectionHeader: {
    paddingX: '16px',
    paddingTop: '18px',
    paddingBottom: '8px',
  },
  moreMenuDrawer: (theme: Theme) => ({
    zIndex: theme.zIndex.drawer + 2,
  }),
  moreMenuTitle: {
    padding: 2,
  },
  moreMenuContainer: {
    width: { xs: '100vw', sm: '350px' },
    paddingX: '12px',
    paddingBottom: '80px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: '1',
  },
  moreMenuSectionTitle: {
    fontWeight: '400',
  },
  downloadAppButton: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    gap: 0.5,
    marginTop: 1,
    marginLeft: 2,
  },
}

export default useStyles
